import { ofType, combineEpics } from "redux-observable";
import { filter, mergeMap } from "rxjs/operators";
import { of } from "rxjs";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import MdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import UsersResource from "@ane/exp-data/lib/resources/UserResources";
import { loadUserAffinity } from "@ane/exp-data/lib/userDetails/CurrentUserDetailsActions";
import { extractWorkspaceName } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import TenantPageConstants from "../ducks/TenantConstants.js";
import TenantActions from "../ducks/TenantActions.js";
import AzureResources from "@ane/exp-data/lib/resources/AzureResources";
import TenantPageUtils from "../utils/TenantPageUtils.js";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import { subscriptionsLoadEpicReducer, workspaceLoadEpicReducer, loadTenantsEpicReducer, ctGroupLoadEpicReducer, rootGroupLoadEpicReducer, WPSWorkspacesLoadEpicReducer, WPSGroupsLoadEpicReducer } from "../WorkspaceSelector/StudioWorkspaceSelector.ducks.js";
const getWorkspacesArgs = {
  filterOnType: TenantPageConstants.LOAD_WORKSPACES,
  loadResource: () => AzureResources.getWorkspaces(),
  loadedAction: (successData) => {
    const workspaces = TenantPageUtils.convertAzureResourceToWorkspaces(successData);
    return of(TenantActions.loadedWorkspaces(workspaces));
  },
  loadingAction: () => TenantActions.loadingWorkspaces(),
  ensureSuccess: true
};
const getWorkspaces = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getWorkspacesArgs);
const getManagementGroupsArgs = {
  filterOnType: TenantPageConstants.LOAD_GROUPS,
  loadResource: (payload) => {
    return MdsDataplaneResource.getExperimentationGroups(payload.workspaceId);
  },
  loadedAction: (successData, payload, error) => {
    if (!error) {
      const workspace = {
        id: payload.workspaceId.toLocaleLowerCase(),
        //Note: there will always be a root group, default to msft workspace if data is empty
        name: extractWorkspaceName(payload.workspaceId, successData == null ? void 0 : successData[0].Path)
      };
      const groups = TenantPageUtils.getSortedWorkspaceGroups(successData);
      return of(TenantActions.loadedManagementGroups(workspace, groups, ""));
    } else {
      return of(TenantActions.loadedManagementGroups(null, [], error));
    }
  },
  loadingAction: () => TenantActions.loadingManagementGroups()
};
const getManagementGroups = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getManagementGroupsArgs);
const getUserManagementGroupArgs = {
  filterOnType: TenantPageConstants.LOAD_CURRENT_GROUP,
  loadResource: () => {
    var _a;
    const workspaceId = (_a = EnvironmentService.getQueryParam(WORKSPACE_ID)) == null ? void 0 : _a.toLowerCase();
    const alias = EnvironmentService.getUser().alias;
    return UsersResource.getUserManagementGroupV2(alias, workspaceId, 0);
  },
  loadedAction: (successData) => {
    const workspace = EnvironmentService.getWorkspaceIdOrDefault(successData == null ? void 0 : successData.WorkspaceId);
    const group = TenantPageUtils.getWorkspaceGroup(workspace, (successData == null ? void 0 : successData.ManagementGroup) || "");
    return of(
      TenantActions.loadedCurrentManagementGroup(workspace, group),
      TenantActions.setPartialUserContext({ workspaceId: workspace }),
      TenantActions.loadManagementGroups(workspace)
    );
  },
  loadingAction: () => TenantActions.loadingCurrentManagementGroup(),
  ensureSuccess: true
};
const getUserManagementGroup = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getUserManagementGroupArgs);
const updateUserManagementGroupArgs = {
  filterOnType: TenantPageConstants.UPDATE_CURRENT_GROUP,
  loadResource: (payload) => {
    const { newGroup, workspaceId } = payload;
    const userInfo = {
      UserName: EnvironmentService.getUser().alias,
      ManagementGroup: newGroup,
      Tenant: "",
      WorkspaceId: workspaceId || ""
    };
    return UsersResource.updateUserManagementGroupV2(userInfo);
  },
  loadedAction: (successData, payload) => {
    const { onComplete } = payload;
    onComplete && onComplete();
    return of(loadUserAffinity(), TenantActions.updatedCurrentManagementGroup());
  },
  loadingAction: () => TenantActions.updatingCurrentManagementGroup(),
  ensureSuccess: true
};
const updateUserManagementGroup = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(updateUserManagementGroupArgs);
const updateUserWorkspace = (action$) => {
  return action$.pipe(
    ofType(TenantPageConstants.SET_USER_CONTEXT),
    filter((value) => {
      const request = value;
      return !!request.payload.workspaceId;
    }),
    mergeMap((value) => {
      const request = value;
      return of(TenantActions.loadManagementGroups(request.payload.workspaceId || ""));
    })
  );
};
const tenantPageEpics = combineEpics(
  getWorkspaces,
  getManagementGroups,
  getUserManagementGroup,
  updateUserWorkspace,
  updateUserManagementGroup,
  subscriptionsLoadEpicReducer.epic,
  workspaceLoadEpicReducer.epic,
  loadTenantsEpicReducer.epic,
  ctGroupLoadEpicReducer.epic,
  rootGroupLoadEpicReducer.epic,
  WPSWorkspacesLoadEpicReducer.epic,
  WPSGroupsLoadEpicReducer.epic
);
export {
  tenantPageEpics as default,
  getManagementGroups,
  getUserManagementGroup,
  getWorkspaces,
  updateUserManagementGroup,
  updateUserWorkspace
};
//# sourceMappingURL=TenantPageEpic.js.map
